import { Endpoints } from '@/docs-partials/clips';
import * as React from 'react';
export default {
  Endpoints,
  React
};